import iconDevicesSvg from '@listening/assets/astro/icons/blog/icon-devices.svg';
import iconPaperSvg from '@listening/assets/astro/icons/blog/icon-paper.svg';
import ctaBannerPng from '@listening/assets/astro/images/cta-banner-md.png';
import mobileMockupPng from '@listening/assets/astro/images/mobile-mockup.png';

import { BlogCtaButton } from './blog-cta-button';

export function CtaBannerMd() {
  return (
    <section className='not-prose my-2'>
      <div
        className='@media(max-width:767px)]:bg-none inline-flex w-full flex-col items-start justify-center gap-8 overflow-hidden rounded-3xl bg-cover bg-no-repeat px-5 pt-8 sm:p-12'
        style={{ backgroundImage: `url(${ctaBannerPng})` }}
      >
        <div className='flex flex-col items-start justify-center gap-4 self-stretch'>
          <div className='text-[2rem] leading-[2.625rem] font-semibold text-neutral-900'>
            Listen to this
          </div>
          <div className='mb-2 flex flex-col items-start justify-start gap-4'>
            <div className='inline-flex items-center justify-start gap-4'>
              <img alt='icon devices' className='size-6' src={iconDevicesSvg} />
              <div>
                <span className='text-lg text-stone-900'>Listen to </span>
                <span className='font-medium'>unlimited</span>
                <span className='text-lg text-stone-900'> research papers</span>
              </div>
            </div>
            <div className='inline-flex items-center justify-start gap-4'>
              <img alt='icon papers' className='size-6' src={iconPaperSvg} />
              <div>
                <span className='text-lg text-stone-900'>Upload from </span>
                <span className='font-medium'>mobile or desktop</span>
              </div>
            </div>
          </div>

          <BlogCtaButton className='relative inline-block w-full cursor-pointer rounded-full border-0 bg-azure-455 px-8 py-[12px] text-center leading-[21px] font-[600] text-neutral-50 no-underline sm:w-auto lg:text-[16px]' />

          <img
            alt='mobile mockup listening.com'
            className='mx-auto mt-4 w-full max-w-[250px] sm:hidden'
            src={mobileMockupPng}
          />
        </div>
      </div>
    </section>
  );
}
